import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { DataModel } from 'legacy/lut/classes/models/DataModel'
import { IFormProfile } from 'legacy/lut/classes/models/IFormProfile'
import businessProfileStoreService from 'legacy/lut/classes/services/BusinessProfileStoreService'
import { searchCodeByName } from 'legacy/lut/components/widgets/public/phoneEditor/helpers/searchCodeByName'
import { mapContactFromContactAllData } from 'legacy/lut/services/contacts/mapping/mapContactFromContactAllData'
import { updateContact } from 'legacy/lut/services/contacts/updateContact'
import { appGetState, IState } from 'legacy/lut/store'
import { ILookupState } from 'legacy/lut/store/state'
import { JSX, PureComponent } from 'react'
import { connect } from 'react-redux'

import { Roles } from 'clickNgo/configs/roles'
import { ContactStatus, IContact } from 'clickNgo/entities/contact'
import { ProfilingCodeType } from 'clickNgo/entities/profilingCode'
import { checkReadOnlyAccess } from 'clickNgo/helpers/access'
import { Loader } from 'core-components/library/loader'
import { ModalDialog } from 'core-components/library/modalDialog'
import { Static } from 'core-components/types'
import { IDataProviderFilter, Logic, Operator } from 'core-components/types'
import { toServerFormat } from 'core/classes/helpers/DateHelper'
import { HttpCancel } from 'core/classes/http'
import { MarketApi } from 'core/classes/services/api/MarketApi'
import { CrudStoreItemCore } from 'core/classes/services/InitializationServiceCore'
import { ADMIN } from 'core/constants/roles'
import { siteBuilderGetState } from 'core/sitebuilder/store'
import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'
import Logger from 'core/utils/Logger'
import { IOnboardingState } from 'onboarding/features/models'
import settings from 'src/config/settings'

import { getCodesDictionary } from '../partnerEditDialog/PartnerFlags'
import { getSeparatedPhone } from '../phoneEditor/helpers/getSeparatedPhone'

import { DialogContent } from './components/DialogContent'
import {
  getContactCodes,
  getContactCodesRequests,
  saveContactCodesRequests,
} from './GetUserRightsAndCampaigns'
import getUserRoles from './getUserRoles'
import { getDefaultReplacementContact } from './helpers/getDefaultReplacementContact'
import { removeUniqueHpRolesFromOtherContacts } from './helpers/removeUniqueHpRolesFromOtherContacts'
import { IAbilityObject, IContactEditDialogProps, IContactEditDialogState } from './models'

import styles from './ContactEditDialog.module.scss'

class WidgetContactEditDialog extends PureComponent<
  IContactEditDialogProps,
  IContactEditDialogState
> {
  constructor(props: IContactEditDialogProps) {
    super(props)
    const entryIdItem = this.props.entryIdItem.clone
      ? this.props.entryIdItem.clone()
      : new DataModel(this.props.entryIdItem)
    let countries
    if (entryIdItem.get('Market')) {
      countries = props.countries.filter((el: any) => {
        return el.market === entryIdItem.get('Market')
      })
    } else {
      countries = props.countries.filter((el: any) => {
        return el.market === appGetState().user.geoMarket
      })
    }
    const countriesCode = this.getCountriesCode(entryIdItem)
    const languageData = this.mappedPreferredLanguage(entryIdItem)

    const country = countries.find((country) => entryIdItem.get('Country') === country.name)
    const phoneCode = country?.phoneCode

    const initMobilePhoneCountryCode =
      entryIdItem.get('MobilePhone_Prefix')?.replace(/^0*/, '') || ''
    const initWorkPhoneCountryCode = entryIdItem.get('WorkPhone_Prefix')?.replace(/^0*/, '') || ''
    const initMobilePhone = entryIdItem.get('MobilePhone')
    const initWorkPhone = entryIdItem.get('WorkPhone')

    if (initMobilePhoneCountryCode && initMobilePhoneCountryCode.match(/^0*/)) {
      entryIdItem.set('MobilePhone_Prefix', initMobilePhoneCountryCode.replace(/^0*/, ''))
    }

    if (initWorkPhoneCountryCode && initWorkPhoneCountryCode.match(/^0*/)) {
      entryIdItem.set('WorkPhone_Prefix', initWorkPhoneCountryCode.replace(/^0*/, ''))
    }

    if (!initMobilePhoneCountryCode && initMobilePhone) {
      const phoneEditorData = getSeparatedPhone({
        phone: initMobilePhone,
        phoneCode,
      })

      entryIdItem.set('MobilePhone_Prefix', phoneEditorData.code)
      entryIdItem.set('MobilePhone', phoneEditorData.phone)
    }

    if (!initWorkPhoneCountryCode && initWorkPhone) {
      const phoneEditorData = getSeparatedPhone({
        phone: initWorkPhone,
        phoneCode,
      })

      entryIdItem.set('WorkPhone_Prefix', phoneEditorData.code)
      entryIdItem.set('WorkPhone', phoneEditorData.phone)
    }

    if (props.onboardingRequestId) {
      entryIdItem.set('OnboardingRequestId', props.onboardingRequestId)
    }

    const roleIds = appGetState().user.roleIds
    // useUserStore().isAdminUser()
    const isAdmin = !!roleIds.find((role) => role === ADMIN)

    const isReadOnly = checkReadOnlyAccess(appGetState().user)

    const contactEmail = entryIdItem.get('Email')?.toLowerCase()
    const contactWithMultiplePartners = props.contactsWithMultiplePartnersData.data.find(
      (contacts) => contacts.email.toLowerCase() === contactEmail
    )
    const replacementContact = contactWithMultiplePartners
      ? getDefaultReplacementContact(entryIdItem)
      : new DataModel({})

    this.state = {
      isLoading: false,
      entryIdItem,
      entryIdItemVersion: 0,
      emailValidation: '',
      mobilePhoneValidation: '',
      workPhoneValidation: '',
      validationMessage: [],
      incorrectValuesMessage: '',
      focusField: null,
      fieldsWithErrors: [],
      fieldsWithAttention: [],
      modifiedFields: [],
      confirmationDialog: false,
      changeStatus: false,
      isAdmin,
      tab: 0,
      replacementContact,
      contactWithMultiplePartners: contactWithMultiplePartners,
      validation: true,
      countries: countries,
      countriesCode: countriesCode,
      regionDisabled: false,
      isUpdateData: false,
      askCloseDialog: false,
      isUpdateDataUserRigth: false,
      isUpdateDataCampaigns: false,
      isUpdateDataTools: false,
      contactSavedCodes: {},
      contactCodes: {},
      showTabs: {},
      contactCodesRequests: {},
      codesDictionary: {},
      LOVdata: {},
      preferredContact: { default: -1, current: -1 },
      readOnly: !!this.props.disabled || isReadOnly,
      maintenance: '',
      toolAccessConditions: [],
      preferredLanguageSource: new Crud({
        fetcher: new Static(languageData),
        keyField: 'name',
      }),
      neverEmailSource: new Crud({
        fetcher: new Static([
          { id: 1, key: '', title: ' No select' },
          { id: 2, key: 'Y', title: 'Yes' },
          { id: 3, key: 'N', title: 'No' },
        ]),
        keyField: 'key',
      }),
      statusSource: new Crud({
        fetcher: new Static([
          { id: 1, key: '', title: ' No select' },
          { id: 2, key: 'Active', title: 'Active' },
          { id: 3, key: 'Inactive', title: 'Inactive' },
        ]),
        keyField: 'key',
      }),
      contriesCrud: new Crud({
        fetcher: new Static(countries),
        keyField: 'value',
      }),
      canModifyNeverEmail: !!appGetState().user.roleIds.find((role) =>
        [
          Roles.SPV_IPBM,
          Roles.IPBM,
          Roles.SPV_TR,
          Roles.PROXIMITY,
          Roles.SPV_CSI,
          Roles.CSI,
          Roles.ADMIN,
          Roles.SUPER_ADMIN_ROLE,
          Roles.COMMUNICATION_PREFERENCE,
        ].includes(role as Roles)
      ),
    }
    {
      this.state.LOVdata['primaryJobRoles'] = CrudStore.get('Dropdowns', 'ContactJobs')
      this.state.LOVdata['primaryJobRoles'].setRoot('ContactJobs')
      this.state.LOVdata['Competitors'] = CrudStore.get('Dropdowns', 'Competitors')
      this.state.LOVdata['Competitors'].setRoot('Competitors')
    }
  }

  public async componentDidUpdate(prevProps: Readonly<IContactEditDialogProps>) {
    if (this.props.entryIdItem && this.props.entryIdItem !== prevProps.entryIdItem) {
      const contactWithMultiplePartners = this.props.contactsWithMultiplePartnersData.data.find(
        (contacts) => contacts.email === entryIdItem.get('Email')
      )

      const replacementContact = contactWithMultiplePartners
        ? getDefaultReplacementContact(this.props.entryIdItem)
        : new DataModel({})

      const entryIdItem = this.props.entryIdItem.clone()
      this.setState({
        entryIdItem,
        entryIdItemVersion: 0,
        emailValidation: '',
        mobilePhoneValidation: '',
        workPhoneValidation: '',
        validationMessage: [],
        incorrectValuesMessage: '',
        fieldsWithErrors: [],
        fieldsWithAttention: [],
        modifiedFields: [],
        replacementContact,
        contactWithMultiplePartners,
      })
    }
    if (this.state.focusField) {
      try {
        this.putFocusField(this.state.focusField)
      } catch (error) {
        Logger.error(error)
      }
    }
  }

  public async componentDidMount() {
    this.setState({ isLoading: true })

    await this.fetchToolAccessConditions()
    await this.fetchMaintenance()
    const isNewContact = this.state.entryIdItem.get('ContactID', '').indexOf('new-') === 0

    await businessProfileStoreService.init(new HttpCancel())

    const fields = [
      'FirstName',
      'LastName',
      'CountryOfBusiness',
      'PreferredLanguage',
      'MobilePhone_Prefix',
      'WorkPhone_Prefix',
      'MobilePhone',
      'WorkPhone',
    ]
    fields.forEach((item: string) => {
      this.setIncorrectField(item)
    })
    this.checkUserRegion()
    await this.checkEmailValidation()
    this.checkPhoneNumberValidation('WorkPhone')
    this.checkPhoneNumberValidation('MobilePhone')
    this.fetchPreferredContact()

    if (isNewContact) {
      this.changeCountyCode()
    }

    if (settings.appIdentifier.id !== 'bpp') {
      const allRoles: string[] = siteBuilderGetState().roles.map((v) => v.id)
      const contactId = String(this.props.dialogEntryId)
      const partnerId = this.state.entryIdItem.get('PartnerID')
      const topPartnerId = this.state.entryIdItem.get('TopPartnerId')
      const promiseUserRightsData = await this.getFlags({
        contactId,
        partnerId,
        topPartnerId,
        type: ProfilingCodeType.UserRights,
      })
      const promiseToolsData = await this.getFlags({
        contactId,
        partnerId,
        topPartnerId,
        type: ProfilingCodeType.Tools,
      })
      const promiseCampaignsData = await this.getFlags({
        contactId,
        partnerId,
        topPartnerId,
        type: ProfilingCodeType.Campaigns,
      })

      const result = await Promise.all([
        promiseUserRightsData,
        promiseToolsData,
        promiseCampaignsData,
      ])
      const userRightsData = result[0]
      const toolsData = result[1]
      const campaignsData = result[2]

      const userRole = getUserRoles(allRoles, appGetState().user.roleIds)
      const isSuperAdmin = appGetState().user.roleIds.includes('SuperAdmin')

      let tab = this.state.tab
      const contactMarket = this.state.entryIdItem.get('Market')

      for (const el in userRightsData.codesDictionary) {
        const data = el && userRightsData.codesDictionary[el]
        const item =
          data &&
          data.find((v) =>
            !settings.region //Check Markets
              ? true
              : v.GeoMarket.includes(contactMarket)
          )
        if (item) {
          //Can't edit code if user doesn't have enough rights
          const isHide = !(
            data &&
            data.find(
              (v) =>
                v.roles.find((role) => userRole[role]) &&
                (!settings.region //Check Markets
                  ? true
                  : v.GeoMarket.includes(contactMarket))
            )
          )
          if (!isSuperAdmin && isHide) {
            delete userRightsData.codesDictionary[el]
          } else {
            tab = this.props.tab === 1 ? 1 : tab
          }
        } else {
          //Can't show code
          delete userRightsData.codesDictionary[el]
        }
        if (isSuperAdmin || this.state.readOnly) {
          tab = this.props.tab === 1 ? 1 : tab
        }
      }

      for (const el in campaignsData.codesDictionary) {
        const data = el && campaignsData.codesDictionary[el]
        const item =
          data && data.find((v) => (!settings.region ? true : v.GeoMarket.includes(contactMarket)))
        if (item) {
          const isHide = !(
            data &&
            data.find(({ roles, Users, GeoMarket }) => {
              const userEmail = appGetState().user.email
              const hasRoleAccess = !roles.length || roles.find((role) => userRole[role])
              const hasUserAccess = !Users.length || Users.find((user) => user === userEmail)
              const hasGeoMarketAccess =
                !settings.region || !GeoMarket.length || GeoMarket.includes(contactMarket)

              return hasGeoMarketAccess && hasRoleAccess && hasUserAccess
            })
          )
          if (!isSuperAdmin && isHide) {
            delete campaignsData.codesDictionary[el]
          } else {
            tab = this.props.tab === 2 ? 2 : tab
          }
        } else {
          delete campaignsData.codesDictionary[el]
        }
        if (isSuperAdmin || this.state.readOnly) {
          tab = this.props.tab === 2 ? 2 : tab
        }
      }

      for (const el in toolsData.codesDictionary) {
        const data = el && toolsData.codesDictionary[el]
        const item =
          data && data.find((v) => (!settings.region ? true : v.GeoMarket.includes(contactMarket)))
        if (item) {
          const isHide = !(
            data &&
            data.find(
              (v) =>
                v.roles.find((role) => userRole[role]) &&
                (!settings.region //Check Markets
                  ? true
                  : v.GeoMarket.includes(contactMarket))
            )
          )
          if (!isSuperAdmin && isHide) {
            delete toolsData.codesDictionary[el]
          } else {
            tab = this.props.tab === 3 ? 3 : tab
          }
        } else {
          delete toolsData.codesDictionary[el]
        }
        if (isSuperAdmin || this.state.readOnly) {
          tab = this.props.tab === 3 ? 3 : tab
        }
      }

      let showContactRelinking = false
      if (!this.state.readOnly) {
        showContactRelinking = true
        tab = this.props.tab === 4 ? 4 : tab
      }

      let showCreateReplacementContact = false
      if (!this.state.readOnly) {
        showCreateReplacementContact = true
        tab = this.props.tab === 5 ? 5 : tab
      }

      this.setState({
        contactCodes: {
          UserRights: userRightsData.contactCodes,
          Tools: toolsData.contactCodes,
          Campaigns: campaignsData.contactCodes,
        },
        contactCodesRequests: {
          UserRights: userRightsData.contactCodesRequests,
          Tools: toolsData.contactCodesRequests,
          Campaigns: campaignsData.contactCodesRequests,
        },
        codesDictionary: {
          UserRights: userRightsData.codesDictionary,
          Tools: toolsData.codesDictionary,
          Campaigns: campaignsData.codesDictionary,
        },
        showTabs: {
          UserRights: true,
          Tools: true,
          Campaigns: true,
          ContactRelinking: showContactRelinking,
          CreateReplacementContact: showCreateReplacementContact,
        },
        tab,
      })
    }

    this.setState({ isLoading: false })
  }

  public fetchToolAccessConditions = async () => {
    const crud = CrudStore.get(CrudStoreItem.ToolAccessPartnerFlags)
    crud.setFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'PartnerId',
          operator: Operator.EQUAL,
          value: this.state.entryIdItem.get('PartnerID'),
        },
      ],
    })
    const result = await crud.fetch()
    if (result && result.items) {
      this.setState({
        toolAccessConditions: result.items,
      })
    }
  }

  public fetchMaintenance = async () => {
    const crud = CrudStore.get(CrudStoreItem.CnGMaintenanceInfo)
    crud.setFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'EndDate',
          operator: Operator.GTE,
          value: toServerFormat(new Date()),
        },
        {
          field: 'StartDate',
          operator: Operator.LTE,
          value: toServerFormat(new Date()),
        },
      ],
    })
    const result = await crud.fetch()
    if (result && result.items.length && result.items[0].MaintenanceText) {
      this.setState({
        maintenance: result.items[0].MaintenanceText,
      })
    }
  }

  public getCountriesCode = (entryIdItem: DataModel) => {
    let countriesCode
    if (entryIdItem.get && entryIdItem.get('Market') && this.props.countries) {
      const result: any = {}
      const region = MarketApi.getRegion(entryIdItem.get('Market')).Region
      const countriesByRegion = this.props.countries.filter((el: any) => {
        return el.region === region
      })
      countriesByRegion.forEach((element: any) => {
        if (!result[element.phoneCode]) {
          result[element.phoneCode] = [element.value]
        } else {
          result[element.phoneCode].push(element.value)
        }
      })
      if (Object.keys(result).length) {
        countriesCode = {
          items: [{ EntryID: 1, codes: result }],
          total: 0,
        }
        return countriesCode
      }
    }
    return this.props.countriesCode
  }

  public fetchPreferredContact = async () => {
    const contactId = this.props.entryIdItem.get
      ? this.props.entryIdItem.get('ContactID')
      : this.props.entryIdItem['ContactID']
    const crudPreferred = CrudStore.get(CrudStoreItem.PreferredContacts)
    crudPreferred.setFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'ContactId',
          operator: Operator.EQUAL,
          value: contactId,
        },
        {
          field: 'UserEmail',
          operator: Operator.EQUAL,
          value: appGetState().user.email,
        },
      ],
    })
    crudPreferred.setPaging({ page: 0, pageSize: 1 })
    const result = await crudPreferred.fetch()
    if (result.items.length) {
      this.setState({ preferredContact: { default: 1, current: 1 } })
    } else {
      this.setState({ preferredContact: { default: 0, current: 0 } })
    }
  }

  public checkUserRegion = async () => {
    let regionDisabled = false
    if (settings.region && this.state.entryIdItem.get('ContactID', '').indexOf('new-') !== 0) {
      const userMarket = appGetState().user.geoMarket
      const userRegion = userMarket ? MarketApi.getRegion(userMarket) : ''

      const contactMarket = this.state.entryIdItem.get('Market')
      const contactRegion = contactMarket ? MarketApi.getRegion(contactMarket) : ''

      if (userRegion && contactRegion && userRegion.Region === contactRegion.Region) {
        regionDisabled = false
      } else if (userRegion && !contactRegion && userRegion.Region === 'EMEA') {
        regionDisabled = false
      } else {
        regionDisabled = true
      }
    }
    this.setState({ regionDisabled })
  }

  public getFlags = async ({
    contactId,
    partnerId,
    topPartnerId,
    type,
  }: {
    contactId: string
    partnerId: string
    topPartnerId: string
    type: string
  }) => {
    const [contactCodes, contactCodesRequests, codesDictionary] = await Promise.all([
      getContactCodes({ contactId, partnerId, topPartnerId, type }),
      getContactCodesRequests(contactId, type),
      getCodesDictionary(type),
    ])

    return {
      contactCodes,
      contactCodesRequests,
      codesDictionary: codesDictionary as IAbilityObject,
    }
  }

  public closeDialogAsk = () => {
    if (
      this.state.modifiedFields.length === 0 &&
      !this.state.isUpdateDataUserRigth &&
      !this.state.isUpdateDataCampaigns &&
      !this.state.isUpdateDataTools
    ) {
      this.props.onClose()
    } else {
      this.setState({ askCloseDialog: true })
    }
  }

  public onChangeField = (
    fieldName: string,
    value: string | number | boolean = '',
    silent?: boolean
  ) => {
    let blockSilent: boolean = !!silent && false
    if (fieldName === 'WorkPhone' || fieldName === 'WorkPhone_Prefix') {
      if (!~this.state.entryIdItem.modified.indexOf(fieldName)) {
        blockSilent = true
      }
    }
    this.state.entryIdItem.set(fieldName, value)
    this.setState(
      {
        modifiedFields: blockSilent ? this.state.modifiedFields : this.state.entryIdItem.modified,
        entryIdItemVersion: this.state.entryIdItem.version,
      },
      () => {
        this.setIncorrectField(fieldName)
      }
    )
  }

  public onChangeFieldInReplacementContact = (
    fieldName: string,
    value: string | number | boolean = ''
  ) => {
    this.setState((prevState) => {
      const currentContact = prevState.replacementContact
      if (currentContact.get(fieldName) === value) {
        return null
      }

      const newReplacementContact = currentContact.clone()
      newReplacementContact.set(fieldName, value)

      return { replacementContact: newReplacementContact }
    })
  }

  public checkPhonePrefix = () => {
    let work_prefix = this.state.entryIdItem.get('WorkPhone_Prefix')
    let mobile_prefix = this.state.entryIdItem.get('MobilePhone_Prefix')
    if (work_prefix) {
      work_prefix = work_prefix.charAt(0) === '+' ? work_prefix.substring(1) : work_prefix
      this.state.entryIdItem.set('WorkPhone_Prefix', work_prefix)
    }
    if (mobile_prefix) {
      mobile_prefix = mobile_prefix.charAt(0) === '+' ? mobile_prefix.substring(1) : mobile_prefix
      this.state.entryIdItem.set('MobilePhone_Prefix', mobile_prefix)
    }
  }

  private checkPhoneNumberHasValue = () => {
    const mobilePhone = this.state.entryIdItem.get('MobilePhone')
    const workPhone = this.state.entryIdItem.get('WorkPhone')

    if (!mobilePhone) {
      this.state.entryIdItem.set('MobilePhone_Prefix', '')
    }

    if (!workPhone) {
      this.state.entryIdItem.set('WorkPhone_Prefix', '')
    }
  }

  public onApply = async (callOnUpdate: boolean = true) => {
    this.setState({ isLoading: true })
    const isContactRelinkingTab = this.state.tab === 4
    const isNewPartnerId = this.state.modifiedFields.includes('NewPartnerID')
    const contactId = String(this.props.dialogEntryId)

    if (isContactRelinkingTab && isNewPartnerId) {
      await this.relinkContact()

      this.setState({ isLoading: false })
      this.props.onClose()
      return
    }

    if (this.state.isUpdateDataUserRigth) {
      await saveContactCodesRequests(
        this.state.contactSavedCodes['UserRights'],
        'UserRights',
        contactId,
        this.state.entryIdItem.get('Market'),
        this.state.entryIdItem.get('Country')
      )
      this.setState({ isUpdateDataUserRigth: false })
    }

    if (this.props.isOnboarding) {
      const crudCountry = CrudStore.get(CrudStoreItem.CountriesTable, 'Find Country')
      const country = await crudCountry.getById({
        id: this.state.entryIdItem.rawData.CountryOfBusiness,
        keyField: 'CC',
      })
      const crud = CrudStore.get(CrudStoreItemCore.Users)
      await crud.create('366', [
        {
          FirstName: this.state.entryIdItem.rawData.FirstName,
          LastName: this.state.entryIdItem.rawData.LastName,
          Applications: 'hpscoutso',
          CountryCode: country.CC,
          Language: this.props.languages.filter(
            (i) => i.name === this.state.entryIdItem.rawData.PreferredLanguage
          )[0].value,
          Active: '1',
          HPOrg: country.HPOrg,
          Email: this.state.entryIdItem.rawData.Email,
          Roles: 'Partner Representative',
        },
      ])
    }

    if (this.state.isUpdateDataCampaigns) {
      await saveContactCodesRequests(
        this.state.contactSavedCodes['Campaigns'],
        'Campaigns',
        contactId,
        this.state.entryIdItem.get('Market'),
        this.state.entryIdItem.get('Country')
      )
      this.setState({ isUpdateDataCampaigns: false })
    }

    if (this.state.isUpdateDataTools) {
      await saveContactCodesRequests(
        this.state.contactSavedCodes['Tools'],
        'Tools',
        contactId,
        this.state.entryIdItem.get('Market'),
        this.state.entryIdItem.get('Country')
      )
      this.setState({ isUpdateDataTools: false })
    }

    await this.changePreferredContact()

    if (this.state.modifiedFields.length && callOnUpdate) {
      const isHpRoleModify = this.state.modifiedFields.includes('PR_HP_ROLE')

      let isUpdated: boolean

      if (isHpRoleModify) {
        const prHPRoleExp = this.props.entryIdItem.get
          ? this.props.entryIdItem.get('PR_HP_ROLEExt')
          : this.props.entryIdItem['PR_HP_ROLEExt']

        const prHPRole = this.props.entryIdItem.get
          ? this.props.entryIdItem.get('PR_HP_ROLE')
          : this.props.entryIdItem['PR_HP_ROLE']

        const isNewContact = this.state.entryIdItem.get('ContactID', '').indexOf('new-') === 0

        const originRolesStr: string = isNewContact ? '' : prHPRoleExp || prHPRole || ''

        const newRolesStr: string = isNewContact
          ? this.state.entryIdItem.get('PR_HP_ROLE')
          : this.state.entryIdItem.get('PR_HP_ROLEExt') || ''

        const originRoles = originRolesStr.split(';')
        const roles = newRolesStr.split(';')

        const newRoles = roles.filter((role) => role && !originRoles.includes(role))

        const partnerId = this.state.entryIdItem.get('PartnerID')
        const contactId = this.state.entryIdItem.get('ContactID')

        const { appSource } = this.props

        if (newRoles.length > 0) {
          isUpdated = await removeUniqueHpRolesFromOtherContacts({
            callback: this.onUpdate,
            newRoles,
            partnerId,
            contactId,
            appSource,
            userEmail: appGetState().user.email,
          })
        } else {
          isUpdated = await this.onUpdate()
        }
      } else {
        isUpdated = await this.onUpdate()
      }

      if (isUpdated) {
        this.setState({ isLoading: false })
        return
      }
    }

    this.setState({ isLoading: false })
    this.props.onClose({ item: this.state.entryIdItem, isUpdated: true })
  }

  public relinkContact = async () => {
    const email = this.state.entryIdItem.get('Email')
    const firstName = this.state.entryIdItem.get('FirstName')
    const lastName = this.state.entryIdItem.get('LastName')
    const newPartnerId = this.state.entryIdItem.get('NewPartnerID')
    const relinkingComment = this.state.entryIdItem.get('RelinkingComment')

    const modifiedValues = this.state.modifiedFields.filter((value) =>
      ['Email', 'FirstName', 'LastName', 'NewPartnerID', 'RelinkingComment'].includes(value)
    )

    const originalContact: IContact = {
      ...mapContactFromContactAllData(this.props.entryIdItem.rawData),
      email,
      firstName,
      lastName,
      newPartnerId,
      relinkingComment,
      modifiedValues,
      status: ContactStatus.Active,
      appId: settings.appIdentifier.id,
    }

    return await updateContact({
      contact: originalContact,
      sourceRequester: appGetState().user.email,
    })
  }

  public onUpdate = async () => {
    const { entryIdItem, fieldsWithErrors, changeStatus } = this.state
    if (changeStatus) {
      this.changeConfirmationDialog()
      return true
    }

    this.checkPhonePrefix()
    this.checkPhoneNumberHasValue()

    this.setState({ isLoading: true })
    const waitAutoComplete500 = new Promise((resolve) => {
      setTimeout(resolve, 550)
    })

    await waitAutoComplete500
    await this.checkEmailValidation(true)
    if (fieldsWithErrors.length) {
      return true
    }
    this.setState({ isLoading: true })
    await this.checkPhotoLink()
    await businessProfileStoreService.changeProfileExt(
      entryIdItem,
      undefined,
      this.props.appSource,
      appGetState().user.email
    )
    this.setState({ modifiedFields: [] })
    return false
  }

  public changePreferredContact = async () => {
    const { preferredContact, entryIdItem } = this.state
    if (preferredContact.default !== -1 && preferredContact.default !== preferredContact.current) {
      const crudPreferred = CrudStore.get(CrudStoreItem.PreferredContacts, 'preferred-contact')

      if (preferredContact.current === 1) {
        await crudPreferred.create('638', [
          {
            ContactId: entryIdItem.get('ContactID'),
            PartnerId: entryIdItem.get('PartnerID'),
            TopPartnerId: entryIdItem.get('TopPartnerId') || entryIdItem.get('TopPartnerID'),
            UserEmail: appGetState().user.email,
          },
        ])
      } else {
        const result = await crudPreferred.fetch()
        await crudPreferred.delete('638', result.items[0])
      }
    }
  }

  public checkPhotoLink = async () => {
    const { entryIdItem } = this.state
    const check = new RegExp('^(?:[a-z]+:)?//', 'i')
    if (check.test(entryIdItem.get('Photo') || '')) {
      // TODO: what is it?
      // this.onChangeField('Photo', entryIdItem.get('Photo'))
    } else {
      if (entryIdItem.get('Photo')) {
        entryIdItem.set('Photo', '')
      }
    }
  }

  public changeCountyCode = () => {
    const { entryIdItem } = this.state

    this.setState((prevState) => {
      const { entryIdItem } = prevState

      const languageData = this.mappedPreferredLanguage(entryIdItem)

      return {
        ...prevState,
        preferredLanguageSource: new Crud({
          fetcher: new Static(languageData),
          keyField: 'name',
        }),
      }
    })

    const countriesCode = this.state.countriesCode.items[0].codes
    if (!(entryIdItem.get('MobilePhone') || '').length) {
      this.onChangeField(
        'MobilePhone_Prefix',
        searchCodeByName(entryIdItem.get('CountryOfBusiness') || '', countriesCode)
      )
      if (entryIdItem['MobilePhone_Prefix']) {
        this.deleteErrorField('MobilePhone_Prefix')
      }
    }
    if (!(entryIdItem.get('WorkPhone') || '').length) {
      this.onChangeField(
        'WorkPhone_Prefix',
        searchCodeByName(entryIdItem['CountryOfBusiness'] || '', countriesCode)
      )
      if (entryIdItem['WorkPhone_Prefix']) {
        this.deleteErrorField('WorkPhone_Prefix')
      }
    }
  }

  public checkFieldValidation = (field: string) => {
    if (!this.state.countriesCode || !this.state.countriesCode.items) {
      return
    }

    const { entryIdItem, validationMessage } = this.state
    const message = validationMessage
    const phoneRegex = /^[0-9]{6,20}$/
    const wRegex = /^[ `~!@#$%^&*()|":<>?.№;_+=/]/
    const emailRegex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
    const value = entryIdItem.get(field)
    if (
      [
        'FirstName',
        'LastName',
        'CountryOfBusiness',
        'PreferredLanguage',
        'MobilePhone',
        'WorkPhone',
        'Email',
      ].indexOf(field) > -1
    ) {
      if (value === null || value === undefined) {
        return true
      }
    }
    switch (field) {
      case 'FirstName':
      case 'LastName':
        return wRegex.test(value || '') || (value || '').length < 1
      case 'CountryOfBusiness':
        return value !== (value || '').toUpperCase() || (value || '').length !== 2
      case 'PreferredLanguage':
        return !this.props.languages.find((item) => item.name === value)
      case 'MobilePhone':
      case 'WorkPhone':
        return !phoneRegex.test(value || '')
      case 'Seniority':
        return !(!value || !!this.props.seniority.find((item) => item.Name === value))
      case 'Salutation':
        return !(!value || !!this.props.salutations.find((item) => item.name === value))
      case 'Email':
        if (!emailRegex.test(value || '')) {
          if (message.indexOf('Wrong email') === -1) {
            message.push('Wrong email')
            this.setState({ validationMessage: message })
          }
        } else {
          if (message.indexOf('Wrong email') !== -1) {
            message.splice(message.indexOf('Wrong email'), 1)
            this.setState({ validationMessage: message })
          }
        }
        return !emailRegex.test(value || '')
    }
    return
  }

  public checkUniqPhoneNumber = async (field: string) => {
    const { entryIdItem } = this.state
    const phone = entryIdItem.get(field) || ''
    const prefix = entryIdItem.get(field + '_Prefix') || ''

    const crud = CrudStore.get(CrudStoreItem.ContactAllData, 'contact edit')

    if (!phone) {
      return ''
    }

    const orFilter = {
      logic: Logic.OR,
      filters: [
        {
          field: 'MobilePhoneFull',
          operator: Operator.EQUAL,
          value: prefix + phone,
        },
        {
          field: 'WorkPhoneFull',
          operator: Operator.EQUAL,
          value: prefix + phone,
        },
      ],
    }
    const partnerSource = ~entryIdItem.get('PartnerID').indexOf('new-')
      ? CrudStore.get(CrudStoreItem.NewPartners, 'Contact edit dialog')
      : CrudStore.get(CrudStoreItem.PartnerAllData, 'Contact edit dialog')

    const partner = await partnerSource.getById({
      id: entryIdItem.get('PartnerID'),
      keyField: 'PartnerID',
    })

    const filter: IDataProviderFilter = {
      logic: Logic.AND,
      filters: [orFilter],
    }

    if (partner?.TopPartnerIDExt || partner?.TopPartnerID) {
      filter.filters.push({
        field: 'TopPartnerID',
        operator: Operator.NOTEQUAL,
        value: partner.TopPartnerIDExt || partner.TopPartnerID,
      })
    }
    if (partner.PartnerIDExt || partner.PartnerID) {
      filter.filters.push({
        field: 'PartnerID',
        operator: Operator.NOTEQUAL,
        value: partner.PartnerIDExt || partner.PartnerID,
      })
    }
    filter.filters.push({
      field: 'ContactID',
      operator: Operator.NOTEQUAL,
      value: '' + entryIdItem.get('ContactID'),
    })

    crud.setFilter(filter)
    crud.setPaging({ page: 0, pageSize: 5 })
    const response = await crud.fetch()
    const rows = [...response.items]
    return !rows.length ? '' : `Such ${field} exists`
  }

  private setPhoneValidation = (field: string, validation: string) => {
    if (field === 'WorkPhone') {
      this.setState({ workPhoneValidation: validation })
    } else {
      this.setState({ mobilePhoneValidation: validation })
    }

    const message = [...this.state.validationMessage]
    const errorText = `Such ${field} exists`
    if (validation === 'error') {
      this.setErrorField(field)
      if (message.indexOf(errorText) === -1) {
        message.push(errorText)
        this.setState({ validationMessage: message })
      }
    } else {
      this.deleteErrorField(field)
      if (message.indexOf(errorText) !== -1) {
        message.splice(message.indexOf(errorText), 1)
        this.setState({ validationMessage: message })
      }
    }
  }

  public checkPhoneNumberValidation = (field: string) => {
    this.checkUniqPhoneNumber(field).then((checkValidation) => {
      const wasNotEdit = !this.state.entryIdItem.isModified(field)

      if (checkValidation && wasNotEdit && !this.isNewContact()) {
        this.setPhoneValidation(field, 'attention')
        return
      }

      if (checkValidation) {
        this.setPhoneValidation(field, 'error')
        return
      }

      this.setPhoneValidation(field, '')
      return
    })
  }

  public checkUniqEmail = async (email: string) => {
    const { entryIdItem, validationMessage } = this.state
    const crud = CrudStore.get(CrudStoreItem.WW_Contacts, 'ContactEditDialog_checkUniqEmail')

    crud.setFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'Email',
          operator: Operator.EQUAL,
          value: email,
        },
        {
          field: 'ContactID',
          operator: Operator.NOTEQUAL,
          value: '' + entryIdItem.get('ContactID'),
        },
      ],
    })

    const response = await crud.fetch({ force: true })
    const rows = [...(response?.items || [])]

    const partnerIdList = rows.map((data) => data.PartnerID)

    const errorText = `Such email exists under next partner(s) ${partnerIdList.join(', ')}`
    const message = validationMessage
    if (rows.length) {
      if (message.indexOf(errorText) === -1) {
        message.push(errorText)
        this.setState({ validationMessage: message })
      }
    } else {
      if (message.indexOf(errorText) !== -1) {
        message.splice(message.indexOf(errorText), 1)
        this.setState({ validationMessage: message })
      }
    }
    return !!rows.length
  }

  public putFocusField = (el: string) => {
    const fieldInClass = {
      FirstName: 'textfield-focus-firstname',
      LastName: 'textfield-focus-lastname',
      CountryOfBusiness: 'autocomplete-focus-countryofbusiness',
      PreferredLanguage: 'autocomplete-focus-preferredlanguage',
      Email: 'textfield-focus-email',
    }

    try {
      if (fieldInClass[el]) {
        const parent = document.getElementsByClassName(fieldInClass[el])[0]
        if (parent) {
          parent.getElementsByTagName('input')[0].focus()
        }
      }
    } finally {
      this.setState({ focusField: null })
    }
  }

  public getMessageForIncorrectValues = (fieldsWithErrors: string[]) => {
    let errorText: JSX.Element | string = ''
    const len = fieldsWithErrors.length

    if (len > 1) {
      errorText = (
        <>
          Fields{' '}
          {fieldsWithErrors.map((el, index) => (
            <>
              <a onClick={() => this.setState({ focusField: el })}>{el}</a>
              {len !== index + 1 ? ', ' : ''}
            </>
          ))}{' '}
          have incorrect values.
        </>
      )
    } else if (len === 1) {
      errorText = (
        <>
          The field{' '}
          <a onClick={() => this.setState({ focusField: fieldsWithErrors[0] })}>
            {fieldsWithErrors[0]}
          </a>{' '}
          has an incorrect value.
        </>
      )
    }

    return errorText
  }

  public mappedPreferredLanguage = (entryIdItem: IFormProfile | DataModel): any[] => {
    const PreferredLanguagesSource = entryIdItem.get('CountryOfBusiness')
      ? this.props.associativeLanguages.filter((lang) => {
          return lang.CountryCode === entryIdItem.get('CountryOfBusiness')
        })
      : []

    const prevLangName = entryIdItem.get('PreferredLanguage')

    const prevLang = this.props.languages.find(({ name }) => name === prevLangName)

    const preferredLanguage = PreferredLanguagesSource.map((lang) => {
      const prettyLang = this.props.languages.find((el) => el.value === lang.value)
      return {
        name: (prettyLang && prettyLang.name) || lang.name,
        value: (prettyLang && prettyLang.value) || lang.value,
      }
    })

    return prevLang
      ? [prevLang, ...preferredLanguage.filter(({ value }) => prevLang.value !== value)]
      : preferredLanguage
  }

  public checkEmailValidation = async (withUniq = false) => {
    const checkValidation =
      (withUniq && (await this.checkUniqEmail(this.state.entryIdItem.get('Email') || ''))) ||
      this.checkFieldValidation('Email')
    const wasNotEdit = !this.state.entryIdItem.isModified('Email')
    if (checkValidation && wasNotEdit && !this.isNewContact()) {
      this.setErrorField('Email')
      this.setState({ emailValidation: 'attention' })
      return
    }
    if (checkValidation) {
      this.setErrorField('Email')
      this.setState({ emailValidation: 'error' })
      return
    }
    this.deleteErrorField('Email', () => {
      const { validationMessage } = this.state
      validationMessage.splice(validationMessage.indexOf('Such email exists'), 1)
      this.setState({ emailValidation: '', validationMessage })
    })

    return
  }

  public setErrorField = (field: string) => {
    const { fieldsWithErrors } = this.state
    if (fieldsWithErrors.indexOf(field) === -1) {
      fieldsWithErrors.push(field)
      const incorrectValuesMessage = this.getMessageForIncorrectValues(fieldsWithErrors)
      this.setState({ fieldsWithErrors, incorrectValuesMessage })
    }
    return
  }

  public deleteErrorField = (field: string, fn?: any) => {
    const { fieldsWithErrors } = this.state
    if (fieldsWithErrors.indexOf(field) !== -1) {
      fieldsWithErrors.splice(fieldsWithErrors.indexOf(field), 1)
      const incorrectValuesMessage = this.getMessageForIncorrectValues(fieldsWithErrors)
      this.setState({ fieldsWithErrors, incorrectValuesMessage }, () => {
        fn && fn()
      })
    }
  }

  public setAttentionField = (field: string) => {
    const { fieldsWithAttention } = this.state
    if (fieldsWithAttention.indexOf(field) === -1) {
      fieldsWithAttention.push(field)
      this.setState({ fieldsWithAttention })
    }
  }

  public deleteAttentionField = (field: string) => {
    const { fieldsWithAttention } = this.state
    if (fieldsWithAttention.indexOf(field) !== -1) {
      fieldsWithAttention.splice(fieldsWithAttention.indexOf(field), 1)
      this.setState({ fieldsWithAttention })
    }
  }

  public isNewContact = () => {
    return this.state.entryIdItem.get('ContactID', '').indexOf('new-') === 0
  }

  public setIncorrectField = (field: string) => {
    const checkValidation = this.checkFieldValidation(field)
    const wasNotEdit = !this.state.entryIdItem.isModified(field)
    if (checkValidation && wasNotEdit /*&& !this.isNewContact()*/) {
      this.deleteErrorField(field)
      this.setAttentionField(field)
      return
    }
    if (checkValidation) {
      this.setErrorField(field)
      this.deleteAttentionField(field)
      return
    }
    this.deleteErrorField(field)
    this.deleteAttentionField(field)
    return
  }

  public onRemoveRequest = async () => {
    this.setState({ isLoading: true })
    if (this.state.entryIdItem.get('ContactID')) {
      const ContactID = this.state.entryIdItem.get('ContactID')
      let crud = CrudStore.get(CrudStoreItem.ContactAllData)
      let contact = await crud.getById({ id: ContactID, keyField: 'ContactID' })
      let isNewContact = false
      if (!contact) {
        isNewContact = true
        crud = CrudStore.get(CrudStoreItem.ContactExt)
        contact = await crud.getById({ id: ContactID, keyField: 'ContactID' })
      }
      const removeId = isNewContact ? contact['EntryId'] : contact['EntryIdExt']

      const newStatus = contact.WorkflowStatus
      const isRejected = newStatus === 'Rejected'
      const isDone = newStatus === 'Done'
      if (removeId) {
        if (isRejected || isDone) {
          await crud.update({ formId: '375', code: 'ContactExt' }, [{ EntryId: removeId }])
        }
        await crud.delete({ formId: '375', code: 'ContactExt' }, { EntryId: removeId }, 'EntryId')
      }
    }

    if (
      this.state.isUpdateDataUserRigth ||
      this.state.isUpdateDataCampaigns ||
      this.state.isUpdateDataTools
    ) {
      const crud = CrudStore.get(CrudStoreItem.ContactAllData)
      const data = await crud.getById(this.state.entryIdItem.get('EntryID'))

      this.setState({ isLoading: false })
      if (data) {
        this.setState({
          entryIdItem: new DataModel(data),
          entryIdItemVersion: 0,
          emailValidation: '',
          mobilePhoneValidation: '',
          workPhoneValidation: '',
          validationMessage: [],
          incorrectValuesMessage: '',
          fieldsWithErrors: [],
          fieldsWithAttention: [],
          modifiedFields: [],
          confirmationDialog: false,
          changeStatus: false,
        })
        this.closeDialogAsk()
      } else {
        this.onApply(false)
      }
    } else {
      this.setState({ isLoading: false })
      this.props.onClose({ isUpdated: true })
    }
  }

  public onSaveStatus = async () => {
    this.setState({ confirmationDialog: false, changeStatus: false }, async () => {
      await this.onUpdate()
      this.setState({ isLoading: false })
      this.props.onClose({ isUpdated: true })
    })
  }

  public changeConfirmationDialog = () =>
    this.setState((prevState) => ({
      confirmationDialog: !prevState.confirmationDialog,
    }))

  private dialogContent = () => {
    return (
      <DialogContent
        state={this.state}
        props={this.props}
        changeConfirmationDialog={this.changeConfirmationDialog}
        onSaveStatus={this.onSaveStatus}
        onRemoveRequest={this.onRemoveRequest}
        closeDialogAsk={this.closeDialogAsk}
        onApply={this.onApply}
        setIsLoading={(value) => {
          this.setState({ isLoading: value })
        }}
        setTab={(value) => {
          this.setState({ tab: value })
        }}
        onChangeField={this.onChangeField}
        onChangeFieldInReplacementContact={this.onChangeFieldInReplacementContact}
        checkPhoneNumberValidation={this.checkPhoneNumberValidation}
        checkEmailValidation={this.checkEmailValidation}
        checkFieldValidation={this.checkFieldValidation}
        changeCountyCode={this.changeCountyCode}
        setContactSavedCodes={(value) => {
          this.setState({ contactSavedCodes: value })
        }}
        setValidation={(value) => {
          this.setState({ validation: value })
        }}
        setChangeStatus={(value) => {
          this.setState({ changeStatus: value })
        }}
        setPreferredContact={(value) => {
          this.setState({ preferredContact: value })
        }}
        setIsUpdateDataUserRights={(value) => {
          this.setState({ isUpdateDataUserRigth: value })
        }}
        setIsUpdateDataCampaigns={(value) => {
          this.setState({ isUpdateDataCampaigns: value })
        }}
        setIsUpdateDataTools={(value) => {
          this.setState({ isUpdateDataTools: value })
        }}
        setAskCloseDialog={(value) => {
          this.setState({ askCloseDialog: value })
        }}
      />
    )
  }

  public render() {
    const { dialogEntryId } = this.props
    const { entryIdItem } = this.state

    if (this.state.isLoading) {
      return (
        <div className={styles.loader}>
          <Loader />
        </div>
      )
    } else {
      if (!this.props.withoutModal) {
        return (
          <ModalDialog
            size={'md'}
            show={!!dialogEntryId && !!entryIdItem}
            onClose={() => this.closeDialogAsk()}
            content={this.dialogContent}
          />
        )
      } else {
        return this.dialogContent()
      }
    }
  }
}

const mapStateToProps = (
  state: IState & ILookupState & { onboarding: IOnboardingState },
  ownProps: Pick<
    IContactEditDialogProps,
    | 'withoutModal'
    | 'dialogEntryId'
    | 'entryIdItem'
    | 'onClose'
    | 'tab'
    | 'disabled'
    | 'isOnboarding'
    | 'appSource'
    | 'onboardingRequestId'
  >
): IContactEditDialogProps => ({
  dialogEntryId: ownProps.dialogEntryId,
  entryIdItem: ownProps.entryIdItem,
  geoMarkets: state.app.user.geoMarkets,
  onClose: ownProps.onClose,
  contactsWithMultiplePartnersData: state.onboarding.commonData.contactsWithMultiplePartners,
  countries: state.lookupOld.references.countries,
  associativeLanguages: state.lookupOld.references.associativeLanguages,
  languages: state.lookupOld.references.languages,
  salutations: state.lookupOld.references.salutations,
  relationship: state.lookupOld.businessProfileWidget.relationship,
  changeMindset: state.lookupOld.businessProfileWidget.changeMindset,
  roles: state.lookupOld.businessProfileWidget.roles,
  status: state.lookupOld.businessProfileWidget.status,
  seniority: state.lookupOld.businessProfileWidget.seniority,
  countriesCode:
    state.lookup.forms.dropdowns.queries.countriesCode ||
    state.lookup.forms.dropdowns.queries[
      `countriesCode_${MarketApi.getRegion(state.app.user.geoMarket).Region}`
    ] ||
    [],
  disabled: ownProps.disabled,
  tab: ownProps.tab,
  isOnboarding: ownProps.isOnboarding,
  onboardingRequestId: ownProps.onboardingRequestId,
  withoutModal: ownProps.withoutModal,
  appSource: ownProps.appSource,
})

const WidgetContactEditDialogConnected = connect(mapStateToProps)(WidgetContactEditDialog)
export { WidgetContactEditDialogConnected as WidgetContactEditDialog }
